import type Program from "@travily/types/models/ProgramsCard";
import type { ProgramsCardAccountTrait, ProgramsCardPhotosTrait } from "@travily/types/models/ProgramsCard";
import { CardGrid } from "@ui/components/CardGrid";
import { EmptyState } from "@ui/components/EmptyState";
import { Illustration } from "@ui/components/Illustration";
import { ProgramCard } from "@/components/ProgramCard/ProgramCard";

type FavoriteProgram = Program & ProgramsCardPhotosTrait & ProgramsCardAccountTrait;

export interface ProgramFavoritesProps {
  empty: { description: string; title: string };
  getFavorited?: (type: string, id: string | number) => boolean;
  programs: FavoriteProgram[];
  onFavoriteToggle?: (favorableType: string, favorableId: string | number) => void;
}

export function ProgramFavorites({ empty, getFavorited, programs, onFavoriteToggle }: ProgramFavoritesProps) {
  if (programs.length === 0) {
    return (
      <EmptyState description={empty.description} illustration={<Illustration name="trips" />} title={empty.title} />
    );
  }

  return (
    <CardGrid>
      {programs.map((program) => (
        <ProgramCard
          favorited={getFavorited ? getFavorited("Program", program.id) : true}
          key={program.id}
          onFavoriteToggle={onFavoriteToggle ? () => onFavoriteToggle("Program", program.id) : undefined}
          program={program}
          showAuthor
        />
      ))}
    </CardGrid>
  );
}
